import styled from '@emotion/styled';

export const Divider = styled.hr`
  background-color: ${props => props.theme.color.secondary};
  height: 1px;
  border: none;
`;
